import { useForm } from "react-hook-form";
import { useEffect } from "react";

export function EmptySerialGenres(props) {
    const genres = props.genres || [];

    const firstGenreId = genres.length > 0 ? genres[0].id : "";

    const { register, handleSubmit, reset } = useForm({
        defaultValues: { genreId: firstGenreId }
    });

    useEffect(() => {
        if (genres.length > 0) {
            reset({ genreId: genres[0].id });
        }
    }, [genres, reset]);

    if (genres.length === 0) {
        return <div style={{ fontSize: '12px', color: '#6b7280', padding: '10px' }}>Усі доступні жанри додано</div>;
    }

    const onSubmit = (data) => {
        props.onSaveClicked(data);
    };

    return (
        <div style={{ paddingTop: '5px', width: '100%' }}>
            <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', gap: '8px' }}>
                <select
                    {...register('genreId')}
                    style={{
                        flex: 1,
                        padding: '8px',
                        borderRadius: '8px',
                        border: '1px solid #d1d5db',
                        backgroundColor: '#fff',
                        outline: 'none'
                    }}
                >
                    {genres.map(genre => (
                        <option key={genre.id} value={genre.id}>
                            {genre.name}
                        </option>
                    ))}
                </select>

                <button type="submit" style={{
                    backgroundColor: '#4f46e5',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: '600',
                    fontSize: '14px'
                }}>
                    Додати
                </button>
            </form>
        </div>
    );
}